import { h } from 'preact';
export const Server = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "2", y: "2", width: "20", height: "8", rx: "2", ry: "2" }),
        h("rect", { x: "2", y: "14", width: "20", height: "8", rx: "2", ry: "2" }),
        h("line", { x1: "6", y1: "6", x2: "6.01", y2: "6" }),
        h("line", { x1: "6", y1: "18", x2: "6.01", y2: "18" })));
};
//# sourceMappingURL=server.js.map